export const AliasTypes = {
  SYSTEM: 'systemAlias',
  STRING: 'stringAlias'
};

export const isSystemAlias = (alias: any) => alias && alias.references;
